module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/banner--tribe_vote-6d0b37bf92c7f1f093b304ff0df3fdf0.jpg";